//@ts-ignore
const bowser = window.$mediavine.bowser.parse(window.navigator.userAgent)

export class Device {
  static get isMobile(): boolean {
    return bowser.platform.type === 'mobile'
  }

  static get isTablet(): boolean {
    return bowser.platform.type === 'tablet'
  }

  static get isMobileOrTablet(): boolean {
    return (
      bowser.platform.type === 'mobile' || bowser.platform.type === 'tablet'
    )
  }

  static get isDesktop(): boolean {
    return !this.isMobileOrTablet
  }

  static get isAndroid(): boolean {
    return bowser.os.name === 'Android'
  }

  static get isIOS(): boolean {
    return bowser.os.name === 'iOS'
  }

  static get isBot(): boolean {
    return bowser.platform.type === 'bot'
  }

  static get os(): string {
    return bowser.os.name || ''
  }

  static get osversion(): string {
    return bowser.os.version as string
  }

  static get browser(): string {
    return bowser.browser.name || ''
  }

  static get supportsScrollAnchor(): boolean {
    // @ts-ignore
    return window.document.body.style.overflowAnchor !== undefined
  }

  static get deviceType(): 'tablet' | 'mobile' | 'desktop' {
    if (this.isTablet) {
      return 'tablet'
    } else if (this.isMobile) {
      return 'mobile'
    } else {
      return 'desktop'
    }
  }
}

export const mapDeviceToFlooring = (device: string) => {
  const map = { mobile: 'phone' }

  return map[device] || device
}
export const mapOsToFlooring = (os: string) => {
  const map = {
    Android: 'Android',
    iOS: 'ios'
  }

  return map[os] || 'Desktop'
}
